import { useEffect, useState } from 'react'

import { PlanningShiftTable } from '@/entities/gridTables/model/planning/PlanningShiftTable'
import { RunsheetShiftTable } from '@/entities/gridTables/model/runsheet/RunsheetShiftTable'
import { StopTypeEnum } from '@/entities/schedules'
import { CurrentScreenType } from '@/entities/userInterface/model/CurrentScreenType'
import { EntityId } from '@reduxjs/toolkit'

export type FlyToSelectedStopArgs = {
  map: L.Map | null
  stopId: EntityId | null
  shiftTables: PlanningShiftTable[] | RunsheetShiftTable[]
  currentScreen: CurrentScreenType
}

export const useFlyToSelectedStop = ({ map, stopId, shiftTables, currentScreen }: FlyToSelectedStopArgs) => {
  // Remember the last selected order or stop
  // TODO: Fly to order based on orderId once we have the unassigned table and inbox table widgets
  const allStopRows = (currentScreen === 'planning' ?
    (shiftTables as PlanningShiftTable[]).flatMap((table) => table?.rows || []) :
    (shiftTables as RunsheetShiftTable[]).flatMap((table) => table?.rows || [])
  )
  const [selectedStopId, setSelectedStopId] = useState<EntityId | null>(null)

  // Focus on the last selected stop
  useEffect(() => {
    if (!map || !stopId || selectedStopId === stopId) return

    const stopRow = allStopRows.find((st) => st.id === stopId)

    if (!stopRow) return

    if (stopRow.stopType === StopTypeEnum.Order &&
      stopRow.customerLatitude &&
      stopRow.customerLongitude &&
      stopRow.customerLatitude !== 0 &&
      stopRow.customerLongitude !== 0
    ) {
      const currentZoomLevel = map.getZoom()

      setSelectedStopId(stopId)
      map.flyTo([stopRow.customerLatitude, stopRow.customerLongitude], currentZoomLevel < 13 ? 13 : currentZoomLevel)
    }
  }, [map, stopId, selectedStopId, allStopRows])
}
